export default __webpack_public_path__ + "static/media/archived.a183acbd.svg";